import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { SportsThemedPillsDirective } from '@frontend/sports/common/ui/sports-themed-pills';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsPill } from '@frontend/ui/pill';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { NgxPopperjsModule } from 'ngx-popperjs';

import { ScoreboardComponent } from '../card-scoreboards/scoreboard.component';
import { EventPickComponent } from '../option-pick/event-pick.component';
import { StatsLastMatchesPerformanceModule } from '../stats-last-matches-performance/stats-last-matches-performance.module';
import { TabBarModule } from '../tab-bar/tab-bar.module';
import { TimerModule } from '../timers/timer.module';
import { MarketGroupsComponent } from './market-groups/market-groups.component';
import { MultiBuilderCardComponent } from './multi-builder-card/multi-builder-card.component';
import { MultiBuilderComboPreventionErrorComponent } from './multi-builder-combo-prevention-error.component';
import { MultiBuilderOnBoardingComponent } from './multi-builder-onboarding/multi-builder-onboarding.component';
import { MultiBuilderOptionsComponent } from './multi-builder-options/multi-builder-options.component';
import { MultiBuilderRoutingModule } from './multi-builder-routing.module';
import { MultiBuilderComponent } from './multi-builder.component';

@NgModule({
    imports: [
        CommonModule,
        EventPickComponent,
        TabBarModule,
        StatsLastMatchesPerformanceModule,
        TimerModule,
        ParticipantImageComponent,
        NgxPopperjsModule,
        MultiBuilderRoutingModule,
        FontResizerComponent,
        DsPill,
        ScrollAdapterComponent,
        ScoreboardComponent,
        IconCustomComponent,
        DsButtonIcon,
        NativePriceFormatterPipe,
        SportsThemedPillsDirective,
    ],
    declarations: [
        MultiBuilderComponent,
        MultiBuilderCardComponent,
        MultiBuilderOptionsComponent,
        MultiBuilderComboPreventionErrorComponent,
        MarketGroupsComponent,
        MultiBuilderOnBoardingComponent,
    ],
    exports: [MultiBuilderComponent, MultiBuilderCardComponent, MultiBuilderComboPreventionErrorComponent],
})
export class MultiBuilderModule {}
